import { all } from 'redux-saga/effects'
import UserSaga from './UserSaga'
import InfluencerSaga from './InfluencerSaga'

//Main Root Saga
const rootSaga = function* rootSaga() {
  yield all([UserSaga(), InfluencerSaga()])
}
export default rootSaga
